import React, { useCallback, useEffect, useMemo, useState } from "react";
import classNames from "classnames";
import { noop, isEmpty } from "lodash";

import ClearIcon from "../../../Icon/Clear";
import { InputPropTypes } from "../../../propTypes";
import "./styles.scss";

const FileInput = ({ input, value, onChange, ...inputProps }) => {
  const inputValue = input?.value || value;
  const [key, setKey] = useState(Math.random());

  useEffect(() => {
    if (!inputValue) {
      setKey(Math.random());
    }
  }, [inputValue]);

  const onClearClick = useCallback(() => {
    const onChangeFn = input?.onChange || onChange;
    onChangeFn(null);
  }, [input?.onChange, onChange]);

  const onInputChange = useCallback(
    event => {
      const { files } = event.target;
      if (isEmpty(files)) {
        event.preventDefault();
        return;
      }

      const onChangeFn = input?.onChange || onChange;
      onChangeFn(files);
    },
    [input?.onChange, onChange]
  );

  const fileName = useMemo(() => {
    if (!inputValue) {
      return "No file chosen";
    }

    return inputValue.length === 1
      ? inputValue[0].name
      : `Chosen ${inputValue.length} files`;
  }, [inputValue]);

  const openFileChoose = useCallback(e => {
    if (e.keyCode === 32) {
      e.target.click();
    }
  }, []);

  return (
    <div style={{ position: "relative" }}>
      <label
        className="mydpd-input-file-container"
        tabIndex={0}
        onKeyDown={openFileChoose}
      >
        <span className="mydpd-input-file-button">Choose File</span>
        <input {...inputProps} key={key} onChange={onInputChange} />
        <span
          className={classNames("mydpd-input-file-name", {
            empty: !inputValue,
          })}
        >
          {fileName}
        </span>
      </label>
      {inputValue && (
        <div onClick={onClearClick} className="mydpd-input-file-icon">
          <ClearIcon />
        </div>
      )}
    </div>
  );
};

FileInput.defaultProps = {
  active: false,
  input: {},
  onChange: noop,
};

FileInput.propTypes = InputPropTypes;

export default FileInput;
